export default class Purl {
  constructor(accounts) {
    if (!accounts) return null;
    const keyMap = {
      ACCOUNT_ID: "id",
      CHECK_ID: "check_id",
      PURL_ACCOUNT_ID: "account_id",
      FIRST_NAME: "first_name",
      LAST_NAME: "last_name",
      SUFFIX: "suffix",
      COMPANY_NAME: "company_name",
      PLAN_TYPE: "plan_type",
      ACCOUNT_SECTION: "section",
      ACCOUNT_ROW: "row",
      ACCOUNT_SEAT_FROM: "seatFrom",
      ACCOUNT_SEAT_TO: "seatTo",
      ACCOUNT_NUM_OF_SEATS: "numOfSeat",
      PRICE_PER_SEAT: "price_per_seat",
      ACCOUNT_TOTAL_SEAT: "total_price",
      ACCOUNT_CREDIT: "credit",
      CLUB_ACCESS: "club_access",
      REP_NAME: "rep_name",
      REP_PHONE: "rep_phone",
      REP_CELL: "rep_cell",
      REP_EMAIL: "rep_email",
      SEGMENT: "segment",
      MAP_PRE_FILTER: "map_pre_filter",
      BENEFIT_SEGMENT: "benefit_segment",
      BENEFIT_SEGMENT_NAME: "benefit_segment_name",
      INCENTIVE_SEGMENT: "incentive_segment",
      ACCEPTED_TERMS: "acceptedTerms",
      TIME_OF_ACCEPTANCE: "timeOfAcceptance",
    };
    const firstAccount = accounts[0];
    const mapAccounts = () => {
      return accounts.map((account) => {
        return {
          id:
            typeof account[keyMap.ACCOUNT_ID] === "string"
              ? Number.parseInt(account[keyMap.ACCOUNT_ID])
              : account[keyMap.ACCOUNT_ID],
          section: account[keyMap.ACCOUNT_SECTION],
          row: account[keyMap.ACCOUNT_ROW],
          seatFrom: account[keyMap.ACCOUNT_SEAT_FROM],
          seatTo: account[keyMap.ACCOUNT_SEAT_TO],
          numOfSeats: account[keyMap.ACCOUNT_NUM_OF_SEATS],
          pricePerSeat: account[keyMap.PRICE_PER_SEAT],
          totalPrice: account[keyMap.ACCOUNT_TOTAL_SEAT],
          credit: account[keyMap.ACCOUNT_CREDIT],
          clubAccess: account[keyMap.CLUB_ACCESS],
          segment: account[keyMap.SEGMENT],
          planType: account[keyMap.PLAN_TYPE],
          mapPreFilter: account[keyMap.MAP_PRE_FILTER],
          benefitSegment: account[keyMap.BENEFIT_SEGMENT],
          benefitSegmentName: account[keyMap.BENEFIT_SEGMENT_NAME],
          incentiveSegment: account[keyMap.INCENTIVE_SEGMENT],
        };
      });
    };
    const mapRepInfo = () => {
      return {
        name: firstAccount[keyMap.REP_NAME],
        email: firstAccount[keyMap.REP_EMAIL],
        phone: firstAccount[keyMap.REP_PHONE],
        cell: firstAccount[keyMap.REP_CELL],
      };
    };
    this.accountId =
      typeof firstAccount[keyMap.PURL_ACCOUNT_ID] === "string"
        ? Number.parseInt(firstAccount[keyMap.PURL_ACCOUNT_ID])
        : firstAccount[keyMap.PURL_ACCOUNT_ID];
    this.firstName = firstAccount[keyMap.FIRST_NAME];
    this.lastName = firstAccount[keyMap.LAST_NAME];
    this.companyName = firstAccount[keyMap.COMPANY_NAME];
    this.benefitSubmissionForm = firstAccount[keyMap.BENEFIT_SUBMISSION_FORM];
    this.accounts = mapAccounts();
    this.rep = mapRepInfo();
    this.acceptedTerms = firstAccount[keyMap.ACCEPTED_TERMS];
    this.timeOfAcceptance = firstAccount[keyMap.TIME_OF_ACCEPTANCE];
  }
}
